import { Picker, List, InputItem, Toast, ActivityIndicator, Button, Modal } from 'antd-mobile';
import React, { useEffect, useState } from 'react';
import styles from './addSubject.module.scss';
import { ApiCore } from '../../api';
// import backBtn from '../../static/icon/backBtn.svg';
import backBtn from '../../static/icon/back_button.png';
import utils from '../../utils/utils';
import { getAbbreviation } from '../../api/data';
import { InformationCircleOutline } from 'antd-mobile-icons';
import { isNewCrm, fetchProjectConfig } from '../../utils/projectConfig';
const Item = List.Item;
const api = new ApiCore();


let timer: any = null

// 姓名缩写填写规则（newCrm=1 时展示）
const ABBR_RULE_TEXT =
  '受试者姓名拼音的首字母（大写）记录受试者姓名缩写，如果姓名是三个字，请填满所有空格，如：姓名“王小红”，填写为|W|X|H|O|；如果姓名是两个字，如：姓名“白云”，填写为|B|A|Y|U| ；如果姓名为四个字或四个字以上，只填前四个字的缩写。如：姓名“司马相如”，填写为|S|M|X|R|';

interface ProjectRecord {
    allocationType: string
    billingCycle: number
    code: string
    createTime: string
    description: string
    editModel: number
    endTime: string
    groupGoal: number
    hiddenField: string[] | null
    icon: string
    id: number
    name: string
    planCode: string
    planVersion: string
    roleCode: string
    status: string
    subjectScaleReportState: number
    type: string
}

function AddSubject(props: any) {
    //输入error
    const [inputError, setInputError] = useState<boolean>(false);
    const [inputError2, setInputError2] = useState<boolean>(false);
    //设置加载状态
    const [loading, setLoading] = useState(false);
    // 强制隐藏中心
    const [hideCenter, setHideCenter] = useState(false);
    //项目列表
    const [projectList, setProjectList] = useState<any>([]);
    //中心列表
    const [centerList, setCenterList] = useState<any>([]);
    //选择的项目
    const [selectProject, setSelectProject] = useState<any>([]);
    //选择的项目实体类
    const [selectProjectEntity, setSelectProjectEntity] = useState<ProjectRecord>();
    //选择的所属中心
    const [selectCenter, setSelectCenter] = useState<any>([]);
    //患者姓名
    const [name, setName] = useState<any>();
    //患者手机号
    const [mobile, setMobile] = useState<any>();
    //受试者编码
    const [subjectCode, setSubjectCode] = useState<any>();
    // 项目配置：newCrm=1 时新建受试者弹窗显示手写「姓名缩写」
    const [newCrm, setNewCrm] = useState<any>('');
    //是否可以选择中心
    const [centerDisabled, setCenterDisabled] = useState(true);
    //项目加载状态
    const [projectLoading, setProjectLoading] = useState(false);
    //项目加载对应类型映射
    const [projectTypeMap, setProjectTypeMap] = useState<{[key: number]: ProjectRecord}>({});
    //是否默认项目以及不可选择
    const [isDefaultProject, setIsDefaultProject] = useState(false);

    //随机类型
    const [groupType, setGroupType] = useState<any>('0');
    //随机分组配置数据
    const [groupList, setGroupList] = useState<any>([]);

    //选择的分组
    const [selectGroup, setSelectGroup] = useState<any>([]);

    //是否隐藏受试者编码
    const [subjectCodeRule, setSubjectCodeRule] = useState<any>('0');
    const [ysbmCode, setYsbmCode] = useState<any>('');

    // 君实受试者知情
    const [informed, setInformed] = useState<number>(0)
    const [informedOptions] = useState(()=> [
        {
            value: 1,
            label: '线上知情',
        },
        {
            value: 2,
            label: '线下知情',
        }
    ])

    const [label, setLabel] = useState('')

    // 受试者名称
    const targetName = sessionStorage.getItem('targetName') || '受试者';
    //悬浮按钮项相关
    let oLeft: any;
    let oTop: any;
    let moving: boolean = false;
    let oW: any;
    let oH: any;
    let htmlWidth: any;
    let htmlHeight: any;
    let bWidth: any;
    let bHeight: any;
    let click: boolean = false;

    useEffect(() => {
        let ele = document.getElementById('t-suspend-button');
        let recordStateLocal = localStorage.getItem('recordState');
        if (ele) {
            if (recordStateLocal) {
                let recordState = JSON.parse(recordStateLocal);
                ele.style.left = recordState.actionBall.left;
                ele.style.top = recordState.actionBall.top;
            }
            ele.addEventListener(
                "touchmove",
                e => {
                    if (e.cancelable) {
                        e.preventDefault()
                    }
                },
                {
                    passive: false
                }
            )
        }
    }, [])
    //当开始触摸
    const onTouchStart = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0];
        click = true;
        if (ele) {
            ele.style.opacity = '1';
            oW = e.clientX - ele?.getBoundingClientRect().left
            oH = e.clientY - ele?.getBoundingClientRect().top
            htmlWidth = document.documentElement.clientWidth
            htmlHeight = document.documentElement.clientHeight
            bWidth = ele.offsetWidth;
            bHeight = ele.offsetHeight;
            oLeft = e.clientX - oW;
            oTop = e.clientY - oH;

            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
            moving = true;
        }
    }

    //当触摸结束
    const onTouchEnd = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        moving = false

        // 左侧距离
        let oLeft1 = oLeft;
        if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
            oLeft1 = 0
        } else {
            oLeft1 = `${htmlWidth - bWidth}px`
        }
        oLeft = oLeft1
        if (ele) {
            ele.style.left = oLeft;
            let recordState = {
                actionBall: {
                    left: ele.style.left,
                    top: ele.style.top
                }
            }
            localStorage.setItem('recordState', JSON.stringify(recordState));
            setTimeout(() => {
                if (ele) {
                    ele.style.opacity = '0.8'
                }
            }, 2000);
        }
    }

    // 当开始触摸
    const onTouchMove = (e: any) => {
        moving && onMove(e)
    }

    // 当触摸
    const onMove = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0]
        click = false

        // 左侧距离
        let oLeft1 = e.clientX - oW
        let oTop1 = e.clientY - oH
        if (oLeft1 < 0) {
            oLeft1 = 0
        } else if (oLeft1 > htmlWidth - bWidth) {
            oLeft1 = htmlWidth - bWidth
        }
        if (oTop1 < 0) {
            oTop1 = 0
        } else if (oTop1 > htmlHeight - bHeight) {
            oTop1 = htmlHeight - bHeight
        }
        oLeft = oLeft1;
        oTop = oTop1;
        if (ele) {
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
        }
    }

    useEffect(() => {
        //设置网页title
        document.title = '添加任务';
        setProjectLoading(true);
        // 初始化设置
        setHideCenter(false)
        api.getProject().then(res => {
            let routeParams = sessionStorage.getItem("activityType")
            let projectKeywordList: any = [];
            const keyword = routeParams === 'TYGJ' ? '同医共济' : routeParams === 'FZCZ' ? '防治卒中' : '';
            if(keyword) {
                projectKeywordList = res.data.filter((item: any) => item.name.includes(keyword));
            } else {
                projectKeywordList = res.data.filter((item: any) => !item.name.includes("同医共济") && !item.name.includes("防治卒中"))
            }
            if (res.code == '0' && res.data) {
                let filterArr = [];
                const _projectMap: {[key: number]: ProjectRecord} = {};
                for (let item of projectKeywordList) {
                    _projectMap[item.id] = item;
                    filterArr.push({
                        label: item.name,
                        value: item.id,
                        code: item.code,
                        editModel: item?.editModel,
                        hiddenField: item?.hiddenField || [],
                    })
                }
                setProjectList(filterArr);
                setProjectTypeMap(_projectMap);
                // 若数量为一默认选中
                let _projectCode = utils.getUrlParams().projectCode;
                let defaultProject: any = {};
                _projectCode && (res.data || []).some((item: any, index: number) => {
                    if (item.code === _projectCode) {
                        defaultProject = item;
                        return true;
                    }
                })
                let isDefaultProject = (Object.keys(defaultProject).length > 0);
                setIsDefaultProject(isDefaultProject);
                if (res.data.length === 1 || isDefaultProject) {
                    let params: any = {
                    }
                    if (isDefaultProject) {
                        params = {
                            projectId: defaultProject.id
                        }
                        setSelectProject([defaultProject.id]);
                        setSelectProjectEntity(defaultProject)
                        setNewCrm(defaultProject?.newCrm)
                        getYsbm(defaultProject.id)
                    } else {
                        params = {
                            projectId: res.data[0].id
                        }
                        setSelectProject([res.data[0].id]);
                        console.log(res.data[0])
                        setSelectProjectEntity(res.data[0])
                        setNewCrm(res.data[0]?.newCrm)
                        getYsbm(res.data[0].id)
                        getGroup(res.data[0].code)
                    }
                    api.getCenterByProjectId(params).then(res => {
                        if (res.code == '0') {
                            if (res.data && res.data.length > 0) {
                                setCenterDisabled(false);
                                let filterArr = [];
                                for (let item of res.data) {
                                    filterArr.push(
                                        {
                                            label: item.name,
                                            value: item.id,
                                            code: item.code
                                        }
                                    )
                                }
                                setCenterList(filterArr);
                                if (res.data.length === 1) {
                                    // 若数量为一默认选中
                                    setSelectCenter([res.data[0].id]);
                                    setHideCenter(res.data[0].name === '自然人医院')
                                }
                            }
                            else {
                                setCenterDisabled(true);
                                setCenterList([])
                            }
                        }
                    })
                }
            }
            setProjectLoading(false);
        })
    }, [])

    //验证输入规则是否符合正则标准
    const checkInputFormat = (value: any) => {
        const checkPhoneRegex = /^1[3-9]\d{9}$/;
        if (!checkPhoneRegex.test(value)) {
            setInputError(true);
          } else {
            setInputError(false);
          }
    }
    //验证输入规则是否符合正则标准
    const checkInputFormat2 = (value: any) => {
        const checkPhoneRegex = /^([A-Z]|-){4,10}$/;
        if (!checkPhoneRegex.test(value)) {
            setInputError2(true);
          } else {
            setInputError2(false);
          }
    }

    //选择项目名称
    const onProjectOk = (value: any) => {
        const entity =  (projectList || []).find((e:any)=> e.value == value[0]);
        const rawProject = projectTypeMap?.[value[0]];
        setSelectProjectEntity(entity)
        // 透传项目配置 newCrm（优先同步从原始项目对象取，避免提交时状态未更新）
        if (rawProject && rawProject.newCrm !== undefined) {
            setNewCrm(rawProject.newCrm);
        } else if (entity?.code) {
            fetchProjectConfig(entity.code).then((cfg) => setNewCrm(cfg?.newCrm));
        }
        setProjectLoading(true);
        setSelectProject(value);
        setSelectCenter([]);
        setCenterList([])
        setSelectGroup([]);
        setGroupType('1')
        setGroupList([])
        setYsbmCode('')
        setHideCenter(false)
        let params = {
            projectId: value[0]
        }
        getYsbm(value[0])
        api.getCenterByProjectId(params).then(res => {
            if (res.code == '0') {
                if (res.data && res.data.length > 0) {
                    setCenterDisabled(false);
                    let filterArr = [];
                    for (let item of res.data) {
                        filterArr.push(
                            {
                                label: item.name,
                                value: item.id,
                                code: item.code,
                            }
                        )
                    }
                    setCenterList(filterArr);
                    // 若数量为一默认选中
                    if (res.data.length === 1) {
                        setSelectCenter([res.data[0].id]);
                        setHideCenter(res.data[0].name === '自然人医院')
                    }
                }
                else {
                    setCenterDisabled(true);
                    setCenterList([])
                }
            }
            setProjectLoading(false);
        })

        let projectCode = projectList.find((item: any) => {
            return item.value == value[0]
        }).code

        getGroup(projectCode)
    }


    const getGroup = (projectCode: any) => {
        let params = {
            projectCode
        }
        api.getGroupByProjectId(params).then((res: any) => {
            if (res.code == 0) {
                setGroupType(res.data.groupType || '0')
                setSubjectCodeRule(res.data.subjectCodeRule || '0')

                let groupList = [];
                if (res.data.configDtoList && res.data.configDtoList.length > 0) {

                    for (let item of res.data.configDtoList) {
                        groupList.push(
                            {
                                label: item.groupName,
                                id: item.id,
                                value: item.groupCode
                            }
                        )
                    }
                }
                setGroupList(groupList);

            }
        })
    }

    //选择中心
    const onCenterOk = (value: any) => {
        setSelectCenter(value);
    }

    //选择分组
    const changeGroup = (value: any) => {
        setSelectGroup(value);
    }

    //当输受试者编码值改变
    const onSubjectCodeChange = (value: any) => {
        setSubjectCode(value)
    }

    //点击中心
    const onClickCenter = () => {
        
        if (selectProject && selectProject.length == 0) {
            Toast.fail('请先选择项目后再进行选择所属中心!', 1);
        }
        else if ((selectProject && selectProject.length > 0) && (centerList && centerList.length == 0)) {
            Toast.fail('当前项目所属中心为空，请重新选择项目！', 1);
        }
    }

    const hiddenCenterCode = ()=> {
        if (hideCenter) {
            return true
        }
        // 项目隐藏中心编码
        if (selectProjectEntity) {
            if (selectProjectEntity.hiddenField?.includes('centerCode')) {
                return true
            }
        }
        return false
    }

    const hiddenDoctorCode = ()=> {
        if (!ysbmCode) {
            return true
        }
        if (selectProjectEntity) {
            if (selectProjectEntity?.hiddenField?.includes('ysbmCode')) {
                return true
            }
        }
        return false
    }

    const hiddenSubjectCode = ()=> {
        if (subjectCodeRule == '1') {
            return true
        }
        if (selectProjectEntity) {
            if (selectProjectEntity?.hiddenField?.includes('subjectCode')) {
                return true
            }
        }
        return false
    }

    //添加提交
    const onSave = () => {
        setLoading(true);
        // fix 新增时，清除缓存
        sessionStorage.removeItem('forceReadonly');
        if ((selectProject && selectProject.length > 0) && (selectCenter && selectCenter.length > 0)) {
            //项目编码
            let projectCode = projectList.find((item: any) => {
                return item.value == selectProject[0]
            }).code

            //中心编码
            let centerCode = centerList.find((item: any) => {
                return item.value == selectCenter[0]
            }).code

            let selectedItem = projectTypeMap[selectProject[0]];
            let projectId = selectedItem && selectedItem.id
            let projectType = selectedItem && selectedItem.type;

            let params: any = {
                projectCode: projectCode,
                centerCode: centerCode,
                subjectCode: hiddenSubjectCode() ? '' : (subjectCode || ''),
                groupCode: selectGroup.length > 0 ? selectGroup[0] : ''
            }
            let isValid = true;
            const regex = /^1[3-9]\d{9}$/;
           
            if(selectProjectEntity?.editModel === 1 ){
                 if(!mobile){
                    Toast.fail('手机号不能为空！', 1);
                    isValid = false;
                  
                }else if(!name){
                    Toast.fail('姓名缩写不能为空！', 1);
                    isValid = false;
                }else if(!regex.test(mobile)){
                    Toast.fail('请填写正确的手机号码!', 1);
                    isValid = false;
                }else if(!/^([A-Z]|-){4,10}$/.test(name)){
                    Toast.fail('姓名缩写仅支持4-10位大写字母格式或者“-”', 1);
                    isValid = false;
                }else if(!informed) {
                    Toast.fail('请选择知情签署方式', 1);
                    isValid = false;
                }
                if(!isValid){
                    setLoading(false);
                    return false
                }
                params.zhName = label
                params.name = name;
                params.mobile = mobile
                params.informed = informed

            }

            // 传统模式 + newCrm=1：新增手写姓名缩写校验与传参
            if (selectProjectEntity?.editModel !== 1 && isNewCrm(newCrm)) {
                if (!name) {
                    Toast.fail('姓名缩写不能为空！', 1);
                    isValid = false;
                } else if (!/^([A-Z]|-){4,10}$/.test(name)) {
                    Toast.fail('姓名缩写仅支持4-10位大写字母格式或者“-”', 1);
                    isValid = false;
                }
                if (!isValid) {
                    setLoading(false);
                    return false
                }
                params.name = name;
            }

            if (groupType == '2' && selectGroup.length == 0) {
                Toast.fail('所属分组不能为空！', 1);
                setLoading(false);
                return false
            }

            api.getPreSignStatus({
                projectCode: projectCode
            }).then((res: any) => {
                // setLoading(false);
                if (res.code == 0) {
                    const _data = res.data || {};
                    if (_data.status == 0) {
                        // 0未签署 1签署 为空的话就跳过判断
                        Modal.alert('', '当前选择的项目未签署服务协议，请签署服务协议后再进行操作。', [
                            {
                                text: '取消', onPress: () => {
                                }
                            },
                            {
                                text: '立即签署', onPress: () => {

                                    props.history.push(`/doctor/laborAgreement?code=${_data.code}`);
                                }
                            }
                        ])
                        return;
                    }
                    if (_data.auditStatus == 'REJECT') { // 'AGREE' 'RUNNING' 'REJECT'
                        Modal.alert('', '您签署的服务协议未通过审核，重新签名后方可继续使用完整功能。请您确保签名正确完整，清晰可辨认。', [
                            {
                                text: '取消', onPress: () => {
                                }
                            },
                            {
                                text: '重新签署', onPress: () => {
                                    api.toGenerateAfreshSignLaborUserAgreement(_data.code).then((res: any) => {
                                        if (res.code == 0) {
                                            const _dataCode = res.data || '';
                                            props.history.push(`/doctor/laborAgreement?code=${_dataCode}`);
                                        } else {
                                            Toast.fail(res.message || '重新生成签署协议失败', 0.8);
                                        }
                                    })
                                }
                            }
                        ])
                        return;
                    }
                } else {
                    Toast.fail(res.message || '查询签署状态失败', 0.8);
                }
                api.addSubject(params).then(res => {
                    if (res.code == '0') {
                        Toast.success('添加成功！', 1);
                        setLoading(false);
                        sessionStorage.setItem('toPhotoEditItem', JSON.stringify({
                            projectCode: selectedItem.code,
                            projectType: projectType,
                            subjectCode: (res.data && res.data.code) || '',
                            subjectScaleReportState: selectedItem.subjectScaleReportState
                        }));
                        if (res.data.hasScreen) {
                            props.history.replace(`checkSubject/${res.data.code}?projectType=${projectType}`)
                        }
                        else {
                            sessionStorage.removeItem('currentState');
                            props.history.replace(`/subjectsDetail/${res.data.code}?projectId=${projectId}&projectType=${projectType}`)
                        }
                    }
                    else {
                        Toast.fail(res.message, 1);
                        setLoading(false);
                    }
                })
            });
        }
        else if (selectProject.length == 0) {
            Toast.fail('选择的项目不能为空！', 1);
            setLoading(false);

        }
        else if (selectCenter.length == 0) {
            Toast.fail('选择的中心不能为空！', 1);
            setLoading(false);
        }
    }

    
    const getYsbm = (projectId: string) => {
        api.getYsbmApi(projectId).then(res => {
            setYsbmCode(res.data)
        })
    }

    const labelChange = async(value: string)=> {
        if (null !== timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(async()=> {
            const repl = value.replaceAll(/[^\u4e00-\u9fa5]/g, '')
            setLabel(repl)
            // newCrm=1 时姓名缩写为手写，不由中文姓名自动生成
            if (isNewCrm(newCrm)) {
                return;
            }
            const { data } = await getAbbreviation(repl);
            setName(data)
        }, 200)
    }

    // 展示姓名缩写填写规则
    const showAbbrRule = () => {
        Modal.alert('姓名缩写填写规则', <p style={{ margin: 0, fontSize: 13, lineHeight: '20px' }}>{ABBR_RULE_TEXT}</p>, [
            { text: '我知道了' },
        ]);
    };

    return (
        <div className={styles.addSubject_content}>
            <div className={styles.form_content}>
                <div className={styles.formItem}>
                    <div className={styles.title}>
                        &ensp;创建
                        {/* 创建新受试者 */}
                    </div>
                    <div className={`${styles.field} ${isDefaultProject ? styles.isDefaultProject : ''}`}>
                        <Picker
                            data={projectList}
                            title="选择项目"
                            cols={1}
                            onOk={(value) => { onProjectOk(value) }}
                            value={selectProject}
                            disabled={isDefaultProject}
                        >
                            <Item arrow={'horizontal'}>
                                <span className={styles.necessary}>*</span>项目名称
                            </Item>
                        </Picker>
                    </div>
                    <div hidden={ hiddenCenterCode() } className={styles.field}>
                        <Picker
                            data={centerList}
                            title="选择所属中心"
                            cols={1}
                            onOk={(value) => { onCenterOk(value) }}
                            value={selectCenter}
                            disabled={centerDisabled}
                        >
                            <Item arrow={'horizontal'} onClick={onClickCenter}>
                                <span className={styles.necessary}>*</span>所属中心
                            </Item>
                        </Picker>
                    </div>
               
                    { 
                    selectProjectEntity?.editModel === 1 &&
                        <>
                        <div className={styles.field} >
                            <InputItem
                                clear
                                value={mobile}
                                type="number"
                                onChange={(value) => { setMobile(value);checkInputFormat(value)  }}
                                error={inputError}
                                onErrorClick={() => { Toast.info('请输入正确的手机号！'); }}
                                maxLength={11}
                         
                            >
                               <span className={styles.necessary}>*</span>手机号
                            </InputItem>
                        </div>
                        <div className={styles.field} >
                            <InputItem
                                clear
                                onChange={labelChange}
                                value={label}
                                maxLength={10}
                            >
                              <span className={styles.necessary}>*</span>中文姓名
                            </InputItem>
                        </div>
                        {isNewCrm(newCrm) ? (
                            <div className={styles.field}>
                                <InputItem
                                    clear
                                    value={name}
                                    onChange={(value: string) => { setName(value); checkInputFormat2(value) }}
                                    maxLength={10}
                                    error={inputError2}
                                    onErrorClick={() => { Toast.info('姓名缩写仅支持4-10位大写字母格式或者“-”', 1); }}
                                >
                                  <span className={styles.necessary}>*</span>姓名缩写
                                  <span
                                    style={{ marginLeft: 6, color: '#6287ec', display: 'inline-flex', alignItems: 'center' }}
                                    onClick={(e) => { e.stopPropagation(); showAbbrRule(); }}
                                  >
                                    <InformationCircleOutline />
                                  </span>
                                </InputItem>
                            </div>
                        ) : (
                            <div className={styles.field} style={{background: '#f1f1f1'}}>
                                <InputItem
                                    clear
                                    value={name}
                                    editable={false}
                                    placeholder='由中文姓名自动生成'
                                >
                                  <span className={styles.necessary}>*</span>姓名缩写
                                </InputItem>
                            </div>
                        )}
                        <div className={styles.field} >
                            <Picker
                                data={informedOptions}
                                title=""
                                cols={1}
                                onOk={(value) => { setInformed(value[0]) }}
                                value={[informed]}
                                disabled={centerDisabled}
                            >
                                <Item arrow={'horizontal'} onClick={onClickCenter}>
                                    <span className={styles.necessary}>*</span>{targetName}知情
                                </Item>
                            </Picker>
                        </div>
                    </>
                    }
                    {
                        selectProjectEntity?.editModel !== 1 && isNewCrm(newCrm) && (
                            <div className={styles.field}>
                                <InputItem
                                    clear
                                    value={name}
                                    onChange={(value: string) => { setName(value); checkInputFormat2(value) }}
                                    maxLength={10}
                                    error={inputError2}
                                    onErrorClick={() => { Toast.info('姓名缩写仅支持4-10位大写字母格式或者“-”', 1); }}
                                >
                                  <span className={styles.necessary}>*</span>姓名缩写
                                  <span
                                    style={{ marginLeft: 6, color: '#6287ec', display: 'inline-flex', alignItems: 'center' }}
                                    onClick={(e) => { e.stopPropagation(); showAbbrRule(); }}
                                  >
                                    <InformationCircleOutline />
                                  </span>
                                </InputItem>
                            </div>
                        )
                    }
                    <div className={styles.field} hidden={groupType == '0'}>
                        {groupType == '2' ? <Picker
                            data={groupList}
                            title="选择所属分组"
                            cols={1}
                            onOk={(value) => { changeGroup(value) }}
                            value={selectGroup}
                        >
                            <Item arrow={'horizontal'} onClick={onClickCenter}>
                                <span className={styles.necessary}>*</span>所属分组
                            </Item>
                        </Picker> :
                            <InputItem
                                editable={false}
                                value='随机分组'
                            >
                                <span className={styles.necessary}>*</span>所属分组
                            </InputItem>}
                    </div>
                    <div className={styles.field} hidden={ hiddenDoctorCode() }>
                        <InputItem clear value={ysbmCode} disabled>医生编码</InputItem>
                    </div>
                    <div className={styles.field} hidden={ hiddenSubjectCode() }>
                        <InputItem
                            clear
                            placeholder="不填写将自动生成"
                            onChange={(value) => { onSubjectCodeChange(value) }}
                        >
                            {/* 受试者编码 */}
                            系统编码
                        </InputItem>
                    </div>
                </div>
            </div>
            <div className={styles.save_content}>
                <Button className={styles.save_btn} type="primary" disabled={loading} onClick={onSave} loading={loading}>添加</Button>
            </div>
            <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />
            <ActivityIndicator animating={projectLoading} size={"small"} text={'正在加载数据'} toast />

            {/* 操作按钮 */}
            <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                <img src={backBtn} alt="back" onClick={() => { props.history.go(-1) }} />
            </div>

        </div>
    )

}

export default AddSubject;